import { createReducer } from '@reduxjs/toolkit';
import { activeGraphicCleared, activeGraphicSet, graphicConstraintsLoaded } from './action';
import { initialQuickEditorGraphicState } from './state';

export const quickEditorGraphicReducer = createReducer(initialQuickEditorGraphicState, (builder) => {
    builder.addCase(activeGraphicCleared, () => ({ ...initialQuickEditorGraphicState }));
    builder.addCase(activeGraphicSet, (state, { payload }) => ({ ...payload }));
    builder.addCase(graphicConstraintsLoaded, (state, { payload }) => ({ ...state, constraints: payload }));
});
